<template>
  <el-table
    :data="countries"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :country="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      countries() {
        return this.$store.getters['country/countries'];
      },

      loading() {
        return this.$store.getters['country/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('country/fetchAll');
    },
  }
</script>
